import React from 'react';

import { DEFAULT_DATE, SELECT_DATE } from 'constants';

// Images
import Calendar from 'assets/images/calendar.svg';

export const CustomDatePickerInput = React.forwardRef((props, ref) => {
  const {
    label,
    labelText,
    inputIcon,
    onClick,
    placeholderText,
    value = '',
    onChange = () => {},
    isDisable,
  } = props;
  return (
    <div ref={ref} className="row">
      <div className="col-lg-7">
        <div className="form-group date-picker-input-container">
          {label || (
            <label htmlFor="">{labelText || SELECT_DATE}</label>
          )}
          <div onClick={!isDisable ? onClick : () => {}} className="datePicker">
            <i>
              <img src={inputIcon || Calendar} alt="calendar" />
            </i>
            <input
              type="text"
              className="form-control"
              placeholder={placeholderText || DEFAULT_DATE}
              value={value}
              onChange={onChange}
              disabled={isDisable}
            />
          </div>
        </div>
      </div>
    </div>
  );
});
